import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import NotFoundPage from 'pages/public/NotFoundPage';

import VouchersList from './VouchersList';
import VouchersShow from './VouchersShow';

const Vouchers = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="list" replace />} />
      <Route path="list" element={<VouchersList />} />
      <Route path="show/:id" element={<VouchersShow />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default Vouchers;
